export interface ProviderEvent {
  [key: string]: any;
}

export abstract class Provider {
  private _eventsQueue: ProviderEvent[] = [];
  protected _isReady: boolean = false;
  private _controller: any;

  public static get is(): string {
    return '';
  }

  protected abstract initialize(): void;

  protected abstract controllerImplementation(): void;

  protected abstract trackingImplementation(event: ProviderEvent): void;

  public push(event: ProviderEvent) {
    if (this._isReady) {
      this.trackingImplementation(event);

      return;
    }

    this._eventsQueue.push(event);
  }

  public ready() {
    this._isReady = true;

    this._eventsQueue.forEach((event: ProviderEvent) => {
      this.trackingImplementation(event);
    });

    this._eventsQueue = [];
  }

  public pause() {
    this._isReady = false;
  }

  public get controller(): any {
    return this._controller;
  }

  public set controller(controller: any) {
    this._controller = controller;
  }
}
